import LabServiceCollection from "@/collections/LabServiceCollection";
import MeasureUnitModel from "@/models/lab/MeasureUnitModel";

export default class MeasureUnitCollection extends LabServiceCollection {
  model() {
    return MeasureUnitModel;
  }

  prepareFilter(CollectionFilter) {
    CollectionFilter.defaultSortAddAsc("name");
  }
}
